module.exports = __webpack_public_path__ + "static/media/control-vs-acceptance.fcddc699.png";